import { useState } from 'react';
import { VideoPlayer } from 'components/index';
import { PiPlusBold } from 'react-icons/pi';
import { IoClose, IoReload } from 'react-icons/io5';
import { BsEraser } from 'react-icons/bs';
import { FaVolumeUp } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import useWindow from 'hooks/useWindow';
import BaseModal from 'components/Modals/BaseModal';

export default function CameraGrid({
  mode,
  cameras,
  openContextMenu,
  contextMenu,
  closeContextMenu,
  addCamera,
  clearCamera,
  clearAllCameras,
}) {
  const [activeAudioIndex, setActiveAudioIndex] = useState(0);
  const { width, height } = useWindow();

  return (
    <div className={'row gap-3 justify-content-center w-100 m-0'}>
      {Array.from({ length: mode.numberOfOptions }).map((_, index) => (
        <div
          className={`mt-3 ${mode.numberOfOptions === 1 ? 'col-12' : 'col-5'} ${
            width < 993 && 'col-12'
          }  d-flex justify-content-center align-items-center bg-primary p-0 cursor-pointer`}
          style={{ aspectRatio: '16/9' }}
          key={index}
          onClick={() => !cameras[index] && addCamera(index)}
        >
          {cameras[index] && (
            <Button
              className="h-100 w-100 p-0"
              onContextMenu={(e) => {
                e.preventDefault();
                openContextMenu(index);
              }}
            >
              <div className="ratio h-100 d-flex justify-content-center align-items-center position-relative">
                <VideoPlayer
                  activeAudioIndex={activeAudioIndex}
                  setActiveAudioIndex={setActiveAudioIndex}
                  selfAudioIndex={index}
                  verticalShrink={mode.name === 'double'}
                  src={`${process.env.PUBLIC_API_URL}/camera_v2/${cameras[index]}/hls/index.m3u8`}
                />
                <div className="w-100 h-100">
                  {activeAudioIndex === index && (
                    <div
                      className="position-absolute top-0 end-0 bg-black rounded-circle p-2 fs-4 d-flex justify-content-center align-items-center z-1 m-2"
                      style={{ width: '32px', height: '32px', right: '0' }}
                    >
                      <FaVolumeUp />
                    </div>
                  )}
                </div>
              </div>
              <BaseModal
                size="sm"
                backgroundColor="white"
                closeButton={false}
                show={contextMenu === index}
                handleShow={closeContextMenu}
              >
                <div
                  className="p-3"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="border-bottom border-black">
                    <Button
                      className="text-black rounded-0 btn-transparent border-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        addCamera(index);
                        closeContextMenu();
                      }}
                    >
                      <span>
                        <IoReload />
                      </span>{' '}
                      Select Camera
                    </Button>
                  </div>
                  <div className="border-bottom border-black">
                    <Button
                      className="text-black rounded-0 btn-transparent border-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        clearCamera(index);
                        closeContextMenu();
                      }}
                    >
                      <span>
                        <BsEraser />
                      </span>{' '}
                      Clear Panel
                    </Button>
                  </div>
                  <div className="border-bottom border-black">
                    <Button
                      className="text-black rounded-0 btn-transparent border-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        clearAllCameras();
                        closeContextMenu();
                      }}
                    >
                      <span>
                        <IoClose />
                      </span>{' '}
                      Clear All Panels
                    </Button>
                  </div>
                  <div className="border-bottom border-black">
                    <Button
                      className="text-black rounded-0 btn-transparent border-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        closeContextMenu();
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </BaseModal>
            </Button>
          )}
          {!cameras[index] && (
            <Button className="btn-transparent">
              <PiPlusBold size={30} />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
